import { Component, EventEmitter, OnInit, Output, Input } from '@angular/core';
import { Router } from '@angular/router';
import { UserInfoService } from 'src/app/common-services/user-info.service';
//Transalation
import { TranslateService } from '@ngx-translate/core';
import { TranslationService } from 'src/app/common-services/translation.service';
import { Permission } from 'src/app/models/permission';
import { HttpRequestService } from 'src/app/common-services/http-request.service';
import { ToastrService } from 'ngx-toastr';
import { PermissionsService } from 'src/app/common-services/permissions.service';

@Component({
  selector: 'app-left-menu',
  templateUrl: './left-menu.component.html',
  styleUrls: ['./left-menu.component.css']
})
export class LeftMenuComponent implements OnInit {

  @Input() isCollapsed: boolean = false;
  @Output() toggleCollapse = new EventEmitter<void>();
  
  userData: any;
  userPermissions: any[] = [];
  browserLang: any;

  menuPermissions: Record<string, string | string[]> = {
    'dashboard': '',
    'gcProfile': 'menu_gc_profile',
    'lcProfile': 'menu_lc_profile',
    
    // Security
    'securityGroup': 'menu_security',
    'roleList': 'menu_role',
    'usersList': 'menu_users',
    
    // Masters
    'masterGroup': 'menu_master',
    'specialisation': 'menu_specialisation',
    'activity': 'menu_activity',
    'subActivity': 'menu_sub_activity',
    'transportArrangement': 'menu_transport_arrangement',
    'kharchiCreditPeriod': 'menu_kharchi_credit_period',
    'raBillCreditPeriod': 'menu_ra_bill_credit_period',
    'typeOfRoads': 'menu_type_of_roads',
    'functionOfRoad': 'menu_function_of_road',
    'typeOfWork': 'menu_type_of_work',
    'brandMake': 'menu_brand_make',
    'categorization': 'menu_categorization',
    'materialCategory': 'menu_material_category',
    'materialSubCategory': 'menu_material_sub_category',
    
    // Status (Subgroup under Master)
    'statusGroup': 'menu_status',
    'supplyStatus': 'menu_supply_status',
    'requisitionStatus': 'menu_requisition_status',
    'projectStatus': 'menu_project_status',
    
    // Project Current Status (Subgroup under Master)
    'projectCurrentStatusGroup': 'menu_project_current_status',
    'rccSubStructure': 'menu_rcc_sub_structure',
    'rccSuperStructure': 'menu_rcc_super_structure',
    'blockWork': 'menu_block_work',
    'internalPlaster': 'menu_internal_plaster',
    
    // Sidebar main items
    'generalContractor': 'menu_general_contractor',
    'subContractor': 'menu_sub_contractor',
    'supplier': 'menu_supplier',
    'project': 'menu_project',
    'upcomingProjects': 'menu_upcoming_projects',
    'requisition': 'menu_requisition',
    'supply': 'menu_supply',
    'connect': 'menu_connect',
    'workOrder': 'menu_work_order',
    'serviceRequestWO': 'menu_service_to_request_wo',
    'inwardBilling': 'menu_inward_billing',
    'workOrderRating': 'menu_work_order_rating',
    'bill': 'menu_bill',
    
    // DPR Group
    'dprGroup': 'menu_dpr',
    'dprDashboard': 'menu_dpr_dashboard',
    'dprMonthlyPlan': 'menu_dpr_monthly_plan',
    'dprDailyEntry': 'menu_dpr_daily_entry',
    
    // Bulk Notification
    'bulkNotification': 'menu_bulk_notification',
    
    // Reports Group & Items
    'reportsGroup': 'menu_reports',
    'reportInApp': 'menu_report_in_app',
    'reportAltius': 'menu_report_altius',
    'reportYoucon': 'menu_report_youcon',
    'reportWhatsapp': 'menu_report_whatsapp',
    'reportSprint': 'menu_report_sprint',
    'reportGcDump': 'menu_report_gc_dump',
    'reportLcDump': 'menu_report_lc_dump',
    'reportSummaryTradewise': 'menu_report_summary_dlr_tradewise',
    'reportSummaryVendorwise': 'menu_report_summary_dlr_vendorwise',
    'reportSubContractorPerformance': 'menu_report_sub_contractor_performance',
    
    // Reset Cache
    'resetCache': 'menu_reset_cache',
    'settings': 'menu_settings',

    // Utilities
    'utilitiesGroup': 'menu_utilities',
    'apiAuditLog': 'menu_api_audit_log'
  };

  constructor(
    private authInfo: UserInfoService, 
    private http: HttpRequestService, 
    private toaster: ToastrService, 
    private router: Router,
    private lang: TranslationService, 
    private translate: TranslateService,
    private permissionsService: PermissionsService
  ) { 
   	//translation
		let userLang=this.lang.selectLang.value 

   
		let defaultLang = localStorage.getItem('lang') || 'en-US';
		translate.addLangs(['en-US', 'hi-IN', 'mr-IN', 'bn-IN']);
		translate.setDefaultLang(defaultLang);
		translate.use(defaultLang);
		this.browserLang = defaultLang;
		this.langChnaged();
		this.lang.selectLang.next(this.browserLang)
  }
  

//translation
langChnaged() {
  const targetLang = (this.browserLang && typeof this.browserLang === 'string') ? this.browserLang : 'en-US';
  this.translate.use(targetLang.match(/en-US|hi-IN|mr-IN|bn-IN/) ? targetLang : 'en-US');
}


  ngOnInit(): void {
    //translation
    this.lang.selectLang.subscribe(res => {

    })

    this.userData = this.authInfo.userInfo();
    this.userPermissions = this.permissionsService.getPermissions();

    if (!this.userData) {
      this.router.navigateByUrl("/auth");
    }
  }

  hasPermission(permission: string | string[]): boolean {
    if (!permission) return true;
    
    const required = Array.isArray(permission) ? permission : [permission];
    
    if (!this.userPermissions || this.userPermissions.length === 0) {
      return false;
    }
    
    return this.userPermissions.some((p: any) => {
      const pName = typeof p === 'string' ? p : p?.permission_name;
      return required.includes(pName);
    });
  }

  showMenu(menuName: string): boolean {
    const perm = this.menuPermissions[menuName];
    if (perm === undefined) return false;
    if (perm === '') return true; // public
    
    return this.hasPermission(perm);
  }

    
  resetCateche()
  {
    
     this.http.request('post','/refresh-cache/','').subscribe(res=>{
    
       this.toaster.success("Cache was reset successfully")
       
     })
  }
  @Output() refreshNotification = new EventEmitter<any>();
  menuClick(event?: any){    
    this.refreshNotification.emit(true);

    // If the sidebar is collapsed and the user interacts with any menu item, expand the sidebar
    if (this.isCollapsed) {
        this.toggleMenu();
    }

    if (event && event.target) {
      const target = event.target as HTMLElement;
      const anchor = target.closest('a');
      if (anchor && anchor.hasAttribute('routerLink')) {
          const routerLink = anchor.getAttribute('routerLink');
          // Clone to safely remove icons without affecting the DOM
          const clone = anchor.cloneNode(true) as HTMLElement;
          const icons = clone.querySelectorAll('mat-icon');
          icons.forEach(i => i.remove());
          
          let titleText = clone.textContent?.trim();

          if (titleText && routerLink) {
              const menuTitles = JSON.parse(localStorage.getItem('menuTitles') || '{}');
              
              let normalizedLink = routerLink;
              if (!normalizedLink.startsWith('/')) {
                  normalizedLink = '/' + normalizedLink;
              }

              menuTitles[normalizedLink] = titleText;
              localStorage.setItem('menuTitles', JSON.stringify(menuTitles));
          }
      }
    }
  }

  menu_Click(url: any){
    if (location.pathname != url) {
      this.router.navigate([url], {});
    }
    else {
      sessionStorage.removeItem("search_result");
      location.reload();      
    }
  }

  temporary_uat_access() {
  //  let is_access =  this.authInfo.decodedToken['Mobile No'] == 'XXXXXXXXXX'

   return true 
   //return is_access 
  }



  showLogoutModal: boolean = false;

  confirmLogoutPop() {
    this.showLogoutModal = true;
  }

  cancelLogout() {
    this.showLogoutModal = false;
  }

  // logout 
  confirmLogout(){
    this.showLogoutModal = false;
    let analyticsObj = {
      user_id: this.userData?.user_id,
      analytics_screen_id: 10,
    };
    
    this.http.request('post', '/analytics/user-analytics/', analyticsObj).subscribe(res => {
    });

    const token = localStorage.getItem('token');
    this.http.request('post', '/user/log-out/', { "user_id": this.userData?.user_id, token: token }).subscribe(res => {
      localStorage.clear();
      this.router.navigateByUrl('/auth');
    }, err => {
      console.log(err);
      localStorage.clear();
      this.router.navigateByUrl('/auth');
    });
  }

  toggleMenu() {
    this.toggleCollapse.emit();
  }
}
